import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import ProductList from '@bit/gerenciatd.unifiedcomponents.product-list';
import ProductItem from '@bit/gerenciatd.unifiedcomponents.product-item';
import { clientCCLIActions } from '@bit/gerenciatd.telcovid.redux-saga-client-c-c-l-i';
import { registerActions as productsCCLIActions } from '@bit/gerenciatd.telcovid.redux-saga-products-c-c-l-i';
import CustomizerComponent from '@bit/gerenciatd.unifiedcomponents.customizer-component';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import CircleImageSlider from '@bit/gerenciatd.unifiedcomponents.circle-image-slider';
import FeaturedPhrase from '@bit/gerenciatd.unifiedcomponents.featured-phrase';
import HoverEffectCard from '@bit/gerenciatd.unifiedcomponents.hover-effect-card';
import ClickBox from '@bit/gerenciatd.unifiedcomponents.click-box';
import CallMeBackFloatingEmp from '@bit/gerenciatd.unifiedcomponents.call-me-back-floating-emp';
import CounselingContact from '@bit/gerenciatd.unifiedcomponents.counseling-contact';
import { actions } from '../../reducers/soluciones';
import SubHeader from '../../components/SubHeader';
import BannerSoluciones from '../../components/Banner';
import IncrementalFigures from '../../components/IncrementalFigures';
import Recommendations from '../../components/Recommendations';
import SectionImage from '../../components/SectionImage';
import SecurityBenefits from '../../components/SecurityBenefits';
import VideoBanner from '../../components/VideoBanner';
import VideoModules from '../../components/VideoModules';
import CallMeBackFloatingEmpProps from '../../constants/CallMeBackFloatingEmpProps.json';
import { paramsSoluciones } from '../../constants/urlParams';
import { actions as commonActions } from '../../reducers/common';
import { splitSpaceAndFirstUpperCase } from '../../utils/common.utils';
import mainSetup from '../../../config/mainSetup';
import './PortadaPage.scss';

const PortadaPage = () => {
  const { solucionesList, solucionesListState } = useSelector(
    state => state.soluciones
  );
  const { constants } = useSelector(state => state.common);
  const { userType, userAuth, contextURL } = useSelector(state => state.context.data);
  const {
    context,
  } = useSelector(
    state => state
  );

  const pathParam = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)

  const originalAlias = useMemo(() => Object.keys(paramsSoluciones).find(
    paramKey => paramsSoluciones[paramKey] === pathParam
  ) || 'soluciones-digitales', [pathParam]);
  const dispatch = useDispatch();

  const isClient = (userType !== undefined && userType === 'Legado' && userAuth !== undefined && userAuth !== 'MC') || window.location.href.includes('col10mgmt');

  // Get data used for the flow logic.
  const getDataFromClient = () => {
    if ((isClient || contextURL.includes('127.0.0.1')) && !sessionStorage.getItem('datosUsuario')) {
      dispatch(clientCCLIActions.getDatosClienteGInit(context));
      dispatch(productsCCLIActions.getConsultaDatosLineasMInit(context));
      dispatch(productsCCLIActions.getConsultaDatosLineaFInit(context));
    }
  }

  useEffect(() => {
    dispatch(commonActions.getBusinessConstants());
    getDataFromClient();
  }, []);

  useEffect(() => {
    dispatch(actions.getSolucionesBegins(originalAlias));
  }, [originalAlias]);

  if (!constants) {
    return null;
  }

  const renderSoluciones = (solucion) => {
    if (Array.isArray(solucionesList) && !solucionesList.length) {
      return null;
    }
    return Object.values(solucion.data.fields).map((item) => {
      switch (item.name) {
        case 'MODULO_BANNER_SOLUCIONES_DIGITALES':
          return (
            <BannerSoluciones {...item.fields} />
          )
        case 'MODULO_VIDEO_SOLUCIONES_DIGITALES':
          return (
            <VideoBanner {...item.fields} />
          )
        case 'MODULO_INTRODUCCION_SOLUCIONES_DIGITALES':
          return <SectionImage {...item.fields} />
        case 'MODULO_RESULTADOS_PORCENTAJES_SOLUCIONES_DIGITALES':
          return <IncrementalFigures {...item.fields} />
        case 'MODULO_RECOMENDACIONES_SOLUCIONES_DIGITALES':
          return <Recommendations {...item.fields} />
        case 'MODULO_VENTAJAS_SOLUCIONES_DIGITALES':
          return <SecurityBenefits {...item.fields} />
        case 'MODULO_BANNER_INTERNO':
          return <ClickBox {...item.fields} />
        case 'MODULO_VENTA_CRUZADA_SOLUCIONES_DIGITALES':
        case 'MODULO_OTROS_PRODUCTOS_SOLUCIONES_DIGITALES':
          return <ProductList {...item.fields} ItemComponent={ProductItem} />
        case 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES':
          return <CircleImageSlider {...item.fields} />
        case 'MODULO_FRASE_DESTACADA_SOLUCIONES_DIGITALES':
          return <FeaturedPhrase {...item.fields} />
        case 'MODULO_NO_TE_PIERDAS_NADA_SOLUCIONES_DIGITALES':
          return <ProductList {...item.fields} ItemComponent={HoverEffectCard} />
        case 'MODULO_CABECERAS_SOLUCIONES_DIGITALES':
          return <SubHeader {...item.fields} />
        case 'MODULO_VIDEO_INTERNO_SOLUCIONES_DIGITALES':
          return <VideoModules {...item.fields} />
        // case 'MODULO_CARROUSEL_SOLUCIONES_DIGITALES':
        //   return <MultiInfo {...item.fields} />
        default:
          return null;
      }
    });
  };
  return (
    <div className="PortadaSoluciones">
      <CallMeBackFloatingEmp SvgIconLoader={SvgIconLoader} Modal={Modal} modalAtencionConfig={constants && constants.modalAtencionConfig} {...CallMeBackFloatingEmpProps} flotanteProps={{ ...CallMeBackFloatingEmpProps.flotanteProps, product: `TI ${splitSpaceAndFirstUpperCase(originalAlias)}` }} />
      {solucionesListState === 'FETCHING'
        && Array.isArray(solucionesList)
        ? [1, 2, 3, 4, 5].map(() => (
          <Skeleton
            style={{
              width: '100%',
              height: '420px',
              marginBottom: '1.5rem',
            }}
          />
        ))
        : solucionesList.map(renderSoluciones)
        }
      {constants ? (
        <CustomizerComponent
          spaId={mainSetup.projectId}
          activityId="EMP-CONTACTO-ASESORAMIENTO-TI"
          component={CounselingContact}
          componentName="counseling-contact"
          customProps={{
            SvgIconLoader, product: `TI ${splitSpaceAndFirstUpperCase(originalAlias)}`, modalAtencionConfig: (constants && constants.modalAtencionConfig) || null, Modal,
          }}
        />
      ) : (
        <Skeleton
          style={{
            width: '100%',
            height: '400px',
          }}
        />
      )}
    </div>
  );
};

export default PortadaPage;
